//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
const { types, referenceTypes, uiTypes } = require("./utils/types");
const { validatorTypes } = require("./utils/validatorTypes");

const models = [
  {
    tableName: "pdf",
    read: true,
    create: true,
    edit: true,
    delete: true,
    references: [],
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "certificate_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "dealer_name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "dealer_location",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "dealer_invoice_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "installation_date",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE_TIME, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sld_renewal_date",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "rto_location",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "delear_invoice_date",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "customer_name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "customer_address",
        type: types.TEXT,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT_AREA, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "customer_phone",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "fitment_name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "fitment_address",
        type: types.TEXT,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT_AREA, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "fitment_phone",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "car_img",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.IMAGE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "fitment_image",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.IMAGE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "vehicle_make",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "vehicle_reg_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "engine_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "chassis_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "roto_seal_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sld_model",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sld_ecu_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "sld_motor_unit",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "speed_sensor_type",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "test_report_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "tac_no",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "speed_limit",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "certifiacte_date",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "points",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
    listFunc: null,
    readFunc: null,
    createFunc: null,
    editFunc: null,
    deleteFunc: null,
  },
];

module.exports = models;
